import { render, staticRenderFns } from "./BillingDocumentStatementAddModal.vue?vue&type=template&id=32b6dffb&"
import script from "./BillingDocumentStatementAddModal.vue?vue&type=script&lang=js&"
export * from "./BillingDocumentStatementAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports